import { useState, useCallback } from "react";
import { AddressDisplayWithIcon } from "../../common/components/FormBuilder/AddressDisplayWithIcon";
import PropertyConfirmation from "./components/InteractiveMap/PropertyConfirmation";
import LawnSizeEstimator from "./components/LawnSizeEstimator/LawnSizeEstimator";
import LawnSizeToolTip from "./components/LawnSizeToolTip/LawnSizeToolTip";
import "./PropertyAreaWrapper.css";
import { useFormContext } from "../../common/contexts/FormContext";
import {
  PropertyAreaWrapperProps,
  PropertyDetail,
} from "../../Interface/scheduler/form";

const renderPropertyDetails = (
  propertyDetails?: PropertyDetail[],
  selectedAreas?: string,
) => {
  if (!propertyDetails) return null;

  return propertyDetails.map((detail) => {
    switch (detail.type) {
      case "addressDisplayWithIcon":
        return <AddressDisplayWithIcon key={detail.id} />;

      case "lawnSizeEstimate":
        return (
          <LawnSizeEstimator
            key={detail.id}
            label={detail.label}
            areaSizes={selectedAreas}
            description={detail.description}
            unit={detail.unit}
          />
        );

      case "tooltip":
        return <LawnSizeToolTip key={detail.id} content={detail.content} />;

      default:
        return null;
    }
  });
};

const PropertyAreaWrapper = ({ element, errors }: PropertyAreaWrapperProps) => {
  const [selectedAreas, setSelectedAreas] = useState<string>("0");
  const [isLeftSidebarVisible, setIsLeftSidebarVisible] =
    useState<boolean>(true);

  const { setFormValues } = useFormContext();

  const handlePropertySelectedArea = useCallback(
    (selectedAreas: { totalSelectedArea: string }) => {
      setSelectedAreas(selectedAreas.totalSelectedArea);
      setFormValues((prevValues) => ({
        ...prevValues,
        [element.id]: selectedAreas.totalSelectedArea,
      }));
    },
    [],
  );

  const toggleLeftSidebar = useCallback(() => {
    setIsLeftSidebarVisible((prev) => !prev);
  }, []);

  return (
    <div
      className="property-area-wrapper"
      style={{ height: "70vh", width: "100%", display: "flex" }}
    >
      <div
        className="left-sidebar"
        style={{
          overflow: "hidden",
          transition: "all 0.3s ease-in-out",
          width: isLeftSidebarVisible ? "260px" : "0",
          opacity: isLeftSidebarVisible ? 1 : 0,
          padding: isLeftSidebarVisible ? "0 20px" : "0",
        }}
      >
        {renderPropertyDetails(element?.propertyDetails, selectedAreas)}
        {errors?.[element?.id] && (
          <div
            className="error-message"
            style={{ color: "red", marginTop: "10px" }}
          >
            {errors[element?.id]}
          </div>
        )}
      </div>
      <div className="map-wrapper" style={{ flex: 1, height: "100%" }}>
        <PropertyConfirmation
          handlePropertySelectedArea={handlePropertySelectedArea}
          onToggleLeftSidebar={toggleLeftSidebar}
          deepLawnPolygon={element?.deepLawnPolygon}
          EnableFrontAndBackLawn={element?.EnableFrontAndBackLawn}
        />
      </div>
    </div>
  );
};

export default PropertyAreaWrapper;
